<template>
  <div>
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="pt-6 text_color">{{ $t("newUi.adminViewform.editPro") }}</div>
    <v-container class="mobileview padding_view">
      <!-- {{$store.state.currentForm.catalogue.filter(o => o.pos == payload.pos)}} -->
      <v-text-field
        v-model="Name_mob"
        v-bind:label="$t('newUi.addItem.itemName')"
        autocomplete="off"
        v-bind:title="$t('')"
        required
      ></v-text-field>
      <v-textarea
        v-bind:label="$t('newUi.addItem.enterDesc')"
        v-model="payload.desc"
        autocomplete="off"
        v-bind:title="$t('')"
        required
        name="text"
        row="2"
        row-height="20"
      ></v-textarea>
      <v-text-field
        v-bind:prefix="this.$store.state.currentForm.symbol"
        v-bind:label="$t('newUi.addItem.price')"
        v-model="payload.price"
        v-bind:title="$t('')"
        autocomplete="off"
        min="0"
        required
        type="number"
      ></v-text-field>
      <v-select
        v-bind:label="$t('newUi.addItem.category')"
        v-bind:value="edit_category"
        :items="category_name"
        @change="setCategory($event)"
        required
      >
      </v-select>
      <v-avatar
        class="ma-3 cursor-pointer mobileview edit-form-img"
        size="100"
        tile
      >
        <v-img v-if="payload.imageurl && !isEditable" :src="addproduct_image" />
        <v-btn
          v-if="payload.imageurl && isEditable"
          @click="handleRemoveImage(payload)"
        >
          <img src="../assets/img/edit_form_remove.svg" />
        </v-btn>
        <v-card
          v-if="!payload.imageurl && isEditable"
          @click="uploading('mobile')"
          flat
          tile
          class="text-center mx-auto border"
          style="padding-top: 20px; height: 100px; width: 100px"
        >
          <img
            class="cursor-pointer plus_icon"
            src="../assets/ui/plus_green.svg"
            alt=""
          />
          <div class="test-center text_color">
            {{ $t("newUi.addItem.upload") }}
          </div>
        </v-card>
        <v-img
          v-if="payload.imageurl && isEditable"
          @click="uploading('mobile')"
          :src="payload.imageurl"
        ></v-img>
      </v-avatar>

      <div class="mobile_data mb-4">
        <v-btn
          @click.prevent="
            add_product_submit(payload.pos, Name_mob, previous_name_mob)
          "
          class="button_padding"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.save") }}
        </v-btn>
        <v-btn
          @click.prevent="cancel"
          class="button_padding desktopView"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.cancel") }}
        </v-btn>

        <!-- <div @click="add_product_more(addproduct_name, addproduct_desc, addproduct_price, addproduct_category, addproduct_image)" class="text-decoration-underline cursor text_color">save and add more</div> -->
      </div>
    </v-container>

    <v-container class="row desktopView padding_view">
      <!-- {{$store.state.currentForm.catalogue.filter(o => o.pos == payload.pos)}} -->
      <div class="col">
        <v-text-field
          v-bind:label="$t('newUi.addItem.itemName')"
          v-model="Name"
          autocomplete="off"
          v-bind:title="$t('')"
          required
        ></v-text-field>
        <v-textarea
          v-bind:label="$t('newUi.addItem.enterDesc')"
          v-model="payload.desc"
          v-bind:title="$t('')"
          required
          name="text"
          row="2"
          row-height="20"
          autocomplete="off"
        ></v-textarea>
        <v-text-field
          v-bind:prefix="this.$store.state.currentForm.symbol"
          v-bind:label="$t('newUi.addItem.price')"
          v-model="payload.price"
          v-bind:title="$t('')"
          autocomplete="off"
          required
          min="0"
          type="number"
        ></v-text-field>
        <v-select
          v-bind:label="$t('newUi.addItem.category')"
          v-bind:value="edit_category"
          :items="category_name"
          @change="setCategory($event)"
          required
        >
        </v-select>
      </div>

      <v-avatar
        class="ma-3 cursor-pointer desktopView edit-form-img"
        size="100"
        tile
      >
        <v-img v-if="payload.imageurl && !isEditable" :src="addproduct_image" />
        <v-btn
          v-if="payload.imageurl && isEditable"
          @click="handleRemoveImage(payload)"
        >
          <img src="../assets/img/edit_form_remove.svg" />
        </v-btn>

        <v-card
          v-if="!payload.imageurl && isEditable"
          @click="uploading('desktop')"
          flat
          tile
          class="text-center mx-auto"
          style="
            padding-top: 20px;
            height: 100px;
            width: 100px;
            background: #f8faf7;
          "
        >
          <img
            class="cursor-pointer plus_icon"
            src="../assets/ui/plus_green.svg"
            alt=""
          />
          <div class="test-center text_color">
            {{ $t("newUi.addItem.upload") }}
          </div>
        </v-card>
        <v-img
          v-if="payload.imageurl && isEditable"
          @click="uploading('desktop')"
          :src="payload.imageurl"
        ></v-img>
      </v-avatar>
    </v-container>
    <div class="desktopView mb-4">
      <v-btn
        @click.prevent="add_product_submit(payload.pos, Name, previous_name)"
        class="button_padding"
        color="#8AB26D"
      >
        {{ $t("newUi.editForm.save") }}
      </v-btn>
      <v-btn
        @click.prevent="cancel"
        class="button_padding desktopView"
        color="#8AB26D"
      >
        {{ $t("newUi.editForm.cancel") }}
      </v-btn>

      <!-- <div @click="add_product_more(addproduct_name, addproduct_desc, addproduct_price, addproduct_category, addproduct_image)" class="text-decoration-underline cursor text_color">save and add more</div> -->
    </div>

    <div id="imageCroper" class="modal">
      <div
        class="modal-content"
        style="display: flex; "
        :style="
          $vuetify.breakpoint.height > 450
            ? { 'justify-content': 'center' }
            : { 'justify-content': 'start' }
        "
      >
        <!--<cropImage />-->
        <div style="position relative">
          <vue-croppie
            ref="croppieRef"
            :enableOrientation="true"
            :enableResize="false"
            :boundary="
              $vuetify.breakpoint.height > 450
                ? { width: 300, height: 300 }
                : { width: 250, height: 250 }
            "
            :viewport="{ width: 240, height: 240 }"
            @result="result"
            @update="update"
          >
          </vue-croppie>
          <div
            class="col d-flex justify-space-between text-center text-white"
            style="background: black; position: absolute; bottom: 0"
          >
            <div
              class="text-center pt-3 cursor-pointer"
              @click="modalToggle('none')"
            >
              <i class="bi bi-chevron-left"></i>{{ $t("newUi.addItem.back") }}
            </div>
            <img
              class="cursor-pointer pt-1"
              src="../assets/ui/rotate_icon.svg"
              alt=""
              @click="rotate(-90)"
            />
            <div class="crop_icon mt-2" @click="crop(), (cropDialog = false)">
              <img
                class="cursor-pointer pt-1"
                src="../assets/ui/right_icon.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router/router";
import { saveFile, setLocale } from "../services/firebase";
import { saveMasterData } from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
import { saveImage } from "../services/firebase";
export default {
  props: ["payload", "current_form_data"],

  data() {
    var category_name = [i18n.t("newUi.addItem.noCate")];
    return {
      sheet: false,
      add_category: false,
      name: "",
      description: "",
      addproduct_category: "",
      addproduct_desc: "",
      addproduct_name: "",
      addproduct_price: 0,
      addproduct_image: "",
      edit_category: this.payload.category
        ? this.payload.category
        : i18n.t("newUi.addItem.noCate"),
      cropped: null,
      cropDialog: false,
      cropDialog2: false,
      croppieElm: null,
      category_name,
      set_overlay: false,
      Name: this.payload.name,
      Name_mob: this.payload.name,
      previous_name: this.payload.name,
      previous_name_mob: this.payload.name,
    };
  },
  mounted() {
    setLocale();
    this.category_names();
    this.set_product_item_null();
  },
  computed: {
    type: function() {
      // console.log(this.payload)
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },

    isEditable: function() {
      if (this.$route.name === "viewform") return false;
      return true;
    },
  },
  methods: {
    handleRemoveImage(product) {
      console.log("handleRemoveImage", product);
      product.imageurl = "";
      console.log("handleRemoveImage product", product);
      console.log("handleRemoveImage this.$store.state", this.$store.state);
    },
    setCategory: function(event) {
      this.addproduct_category = event;
    },
    category_names: function() {
      let list = this.$store.state.currentForm.catalogue.filter(
        (o) => o.type == "category"
      );
      list.forEach((list) => {
        this.category_name.push(list.name);
      });
    },
    add_catag: function(name, description) {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "category",
        name: name,
        description: description,
      });
      // console.log(this.$store.state.currentForm.catalogue)
    },
    additem: function(name, description, price, category, image) {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "item",
        name: name,
        desc: description,
        imageurl: image,
        price: price,
        qtty: 0,
        category: category,
      });
      // console.log(this.$store.state.currentForm);
    },
    add_product_more() {
      // this.additem(name, description, price, category, image)
      this.saveCurrentForm();
      this.set_product_item_null();
      this.sheet = true;
    },
    add_product_submit(pos, name, previous_name) {
      console.log("edit form ");
      if (this.edit_category == i18n.t("newUi.addItem.noCate")) {
        this.payload.category = "";
      }

      if (this.addproduct_category != "") {
        if (this.addproduct_category == i18n.t("newUi.addItem.noCate")) {
          this.payload.category = "";
        } else if (
          this.addproduct_category != "" &&
          this.addproduct_category != i18n.t("newUi.addItem.noCate")
        ) {
          this.payload.category = this.addproduct_category;
        }
      }
      if (name == null || name == 0 || name == "") {
        alert(i18n.t("alertText.itemNameAlert"));
      } else if (name.length > 100) {
        alert(i18n.t("alertText.itemMax"));
      } else if (
        parseFloat(this.payload.price) < 0 ||
        !parseFloat(this.payload.price) ||
        this.payload.price == ""
      ) {
        alert(i18n.t("alertText.validatePriceAlert"));
      } else if (parseFloat(this.payload.price) > 999999) {
        alert(i18n.t("alertText.pricelimit"));
      } else {
        var decimal_exists = false;
        var decimal = this.payload.price.split(".")[1];
        if (decimal) {
          if (decimal.length > 2) {
            decimal_exists = true;
          }
        }
        var exists = false;
        this.$store.state.currentForm.catalogue.map((each_category) => {
          if (each_category.type == "item") {
            if (
              previous_name != name &&
              each_category.name.toLowerCase().replace(/ /g, "") ===
                name.toLowerCase().replace(/ /g, "")
            ) {
              exists = true;
            }
          }
        });
        if (exists) alert(i18n.t("alertText.productExist"));
        else if (decimal_exists) alert(i18n.t("alertText.roundOffDigits"));
        else {
          console.log("add_product_submit else");
          this.payload.name = name;
          var currentdata = this.$store.state.currentForm;
          for (let item = 0; item < currentdata.catalogue.length; item++) {
            if (currentdata.catalogue[item].pos == pos) {
              // this.payload.category = this.addproduct_category
              this.$store.state.currentForm.catalogue[item] = this.payload;
              if (
                router.currentRoute.fullPath ==
                "/admin/viewform/" + this.$store.state.currentForm.pos
              ) {
                this.saveCurrentForm();
              } else {
                this.saveCurrentFormRoute();
                // router.push(
                //   "/admin/viewform/" + this.$store.state.currentForm.pos
                // );
              }
            }
          }
        }
      }
    },
    set_product_item_null() {
      this.addproduct_category = "";
      this.addproduct_desc = "";
      this.addproduct_image = "";
      this.addproduct_name = "";
      this.addproduct_price = "";
    },
    checkLength(event) {
      if (event.length > 100) {
        this.payload.name = event.slice(0, -1);
        alert(i18n.t("alertText.itemMax"));
        event = event.slice(0, -1);
      } else if (event.length <= 100) {
        this.payload.name = event;
      }
    },
    set_category_item_null() {
      this.name = "";
      this.description = "";
    },
    submit: function() {
      this.sheet = true;
    },
    add_category_open: function() {
      this.add_category = true;
    },
    add_category_submit: function(name, description) {
      this.add_catag(name, description);
      this.saveCurrentForm();
      this.add_category = false;
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    cancel: function() {
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    add_category_more: function(name, description) {
      this.add_catag(name, description);
      this.saveCurrentForm();
      this.set_category_item_null();
      this.add_category = true;
    },
    saveCurrentFormRoute: function() {
      console.log("saveCurrentFormRoute");
      // var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      // console.log(this.$store.state);
      if (
        this.payload.name == null ||
        this.payload.name.length == 0 ||
        this.payload.name == ""
      ) {
        alert(
          i18n.t("alertText.validateNameAlert", { type: this.payload.type })
        );
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else if (
        parseFloat(this.payload.price) < 0 ||
        !parseFloat(this.payload.price) ||
        this.payload.price == ""
      ) {
        alert(i18n.t("alertText.validatePriceAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        this.set_overlay = true;
        var elethis = this;
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
              elethis.set_overlay = false;
            } else {
              store.dispatch("setOverlay", false);
              elethis.set_overlay = false;
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
        });
      }
    },
    saveCurrentForm: function() {
      console.log("saveCurrentForm");

      // var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      // console.log(this.$store.state);
      if (
        this.payload.name == null ||
        this.payload.name.length == 0 ||
        this.payload.name == ""
      ) {
        alert(
          i18n.t("alertText.validateNameAlert", { type: this.payload.type })
        );
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else if (
        parseFloat(this.payload.price) < 0 ||
        !parseFloat(this.payload.price) ||
        this.payload.price == ""
      ) {
        alert(i18n.t("alertText.validatePriceAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        this.set_overlay = true;
        var elethis = this;
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
              elethis.set_overlay = false;
            } else {
              // alert(i18n.t("alertText.uploadText"));
              store.dispatch("setOverlay", false);
              elethis.set_overlay = false;
              router.go();
            }
          }
        );
        console.log(
          "this.$store.state.currentForm",
          this.$store.state.currentForm
        );
        saveMasterData(function(err) {
          console.log(err);
        }, this.$store.state);
      }
    },
    modalToggle: function(display) {
      var modal = document.getElementById("imageCroper");
      modal.style.display = display;
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };
    },
    crop() {
      // debugger;
      let options = {
        type: "base64",
        format: "jpeg",
        circle: false,
      };
      let elethis = this;
      var uid = this.$store.state.profile.uid;
      elethis.set_overlay = true;
      this.$refs.croppieRef.result(options).then(function(output) {
        elethis.cropped = output;
        // console.log(output);
        elethis.modalToggle("none");
        saveImage(uid, new Date().getTime(), output, function(error, newurl) {
          if (error) {
            alert(i18n.t("alertText.uploadFail"));
          } else {
            elethis.payload.imageurl = newurl;
          }
          setTimeout(() => {
            elethis.set_overlay = false;
          }, 1500);
        });
      });
    },
    crop1() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let options = {
        format: "jpeg",
        circle: true,
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output;
      });
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      this.d = val;
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    uploading: function(name) {
      const input = document.createElement("input");
      const elethis = this,
        elementThis = this;
      input.setAttribute("type", "file");
      input.addEventListener("change", function() {
        // console.log(e);
        if (name == "mobile") {
          //elethis.cropDialog = true;
          elementThis.modalToggle("block");
        } else if (name == "desktop") {
          //elethis.cropDialog2 = true;
          elementThis.modalToggle("block");
        }
        setTimeout(() => {
          // console.log(elethis.$refs);
          elethis.$refs.croppieRef.bind({
            url: window.URL.createObjectURL(input.files[0]),
            zoom: 0.8,
          });
        }, 200);
      });
      input.click();
      return false; // avoiding navigation
    },
  },
};
</script>
<style lang="scss">
.button_padding {
  margin-right: 10px;
  color: white !important;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-align: center;
  text-transform: none;
  cursor: pointer;
}

input[type="number"] {
  margin-bottom: 0px;
  border: none;
  margin-top: 0px;
}
.icon_color {
  color: #8ab26d;
  justify-content: center;
  font-size: 20px;
  width: 26px;
  height: 26px;
  background-color: #f8faf7;
  padding: 5px;
  margin: 3px;
  border-radius: 3px;
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
.edit-form-img {
  position: relative;
}

.edit-form-img button {
  background: rgb(255 255 255 / 90%) !important;
  position: absolute;
  z-index: 1;
  padding: 0 !important;
  min-width: 24px !important;
  margin: 0;
  right: 5px;
  top: 5px;
  height: 24px !important;
  width: 24px !important;
}

.edit-form-img button img {
  max-width: 20px;
}
@media (min-width: 320px) and (max-width: 960px) {
  .mobile_data {
    text-align: center;
  }
  .v-application .edit-form-img {
    margin: 0 auto 10px !important;
    display: block !important;
  }

  .v-application .edit-form-img + .mobile_data button {
    margin-right: 0;
  }
}
@media (max-width: 1024px) {
  body .upload-image-box .v-card img {
    width: auto !important;
  }
}
</style>
